import { gql } from '@apollo/client';
import { Bin } from '../types/bin/bin';
import { BinStatus } from '../types/bin/binStatus';
import { Lot } from '../types/lot/lot';
import { Product } from '../types/product';
import { ProductMasterData } from '../types/product_master_data/productMasterData';
import { StockLocation } from '../types/stock_location/stockLocation';
import { BinFragment } from './bin.graphql';
import { BinStatusFragments } from './binStatus.graphql';
import { CsvUploadInput } from './csvUploadConfiguration.graphql';
import { LotFragments } from './lot.graphql';
import { ProductFragments } from './product.graphql';
import { ProductMasterDataFragments } from './productMasterData.graphql';
import { StockLocationFragments } from './stockLocation.graphql';

const parseFile = gql`
  mutation ParseFile($state: ParsedDataInput!, $input: CsvUploadInput!) {
    parseFile(state: $state, input: $input) {
      stockLocations {
        ...StockLocation
      }
      bins {
        ...Bin
      }
      binStatuses {
        ...BinStatus
      }
      products {
        ...Product
      }
      productMasterData {
        ...ProductMasterData
      }
      lots {
        ...Lot
      }
    }
  }
  ${StockLocationFragments.stockLocation}
  ${BinFragment.bin}
  ${BinStatusFragments.binStatus}
  ${ProductFragments.product}
  ${ProductMasterDataFragments.productMasterData}
  ${LotFragments.lot}
`;

export interface ParseFileVariables {
  state: ParsedFileData;
  input: CsvUploadInput;
}

export interface ParseFileResponse {
  parseFile: ParsedFileData;
}

export interface ParsedFileData {
  stockLocations: StockLocation[];
  bins: Bin[];
  binStatuses: BinStatus[];
  products: Product[];
  productMasterData: ProductMasterData[];
  lots: Lot[];
}

const onboardCompany = gql`
  mutation OnboardCompany($data: OnboardingDataInput!) {
    onboardCompany(data: $data) {
      id
    }
  }
`;

export interface OnboardCompanyVariables {
  data: {
    company: {
      id: string;
      name: string;
    };
    users: string[];
    entities: ParsedFileData;
  };
}

export interface OnboardCompanyResponse {
  onboardCompany: {
    id: string;
  };
}

const fileToRows = gql`
  mutation FileToRows($input: CsvUploadInput!) {
    fileToRows(input: $input) {
      companyId
    }
  }
`;

export interface FileToRowsVariables {
  input: CsvUploadInput;
}

export interface FileToRowsResponse {
  fileToRows: {
    companyId: string;
  };
}

export const OnboardingMutations = {
  parseFile,
  onboardCompany,
  fileToRows,
};
